import React from "react";
import { Link } from "react-router-dom";
import { CEmblem } from "@/components/Brand";

const LINKS = [
  { to: "/a-propos", label: "À propos" },
  { to: "/contribuer", label: "Contribuer" },
  { to: "/contact", label: "Contact" },
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/confidentialite", label: "Politique de confidentialité" },
  { to: "/marque", label: "Marque" },
];

const linkCls = "text-sm text-paper/80 hover:text-orange transition-colors duration-200";

export const Footer = () => {
  return (
    <footer className="mt-24 bg-ink text-paper relative overflow-hidden">
      {/* Filigrane emblème */}
      <div aria-hidden className="pointer-events-none select-none absolute right-[-4%] bottom-[-8%] w-[60%] max-w-[680px] opacity-[0.06]">
        <CEmblem className="w-full h-auto" primary="#F7F5F0" secondary="#F7F5F0" />
      </div>

      <div className="mx-auto max-w-7xl px-5 md:px-8 py-16 relative z-10 grid gap-10 md:grid-cols-[1.3fr_1fr]">
        {/* Identité */}
        <div>
          <div className="flex items-center gap-2">
            <CEmblem className="h-8 w-8" primary="#F7F5F0" secondary="#FF4D1C" />
            <p className="font-logo font-black text-2xl">CONTRE-ÉPREUVE</p>
          </div>
          <p className="text-orange text-sm font-medium mt-2">Faits, sources et zones de doute.</p>
          <p className="text-paper/60 text-sm mt-6 max-w-xs leading-relaxed">
            Projet éditorial indépendant consacré aux faits, aux sources et aux récits publics.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <p className="text-orange font-bold text-xs uppercase tracking-wide mb-4">Navigation</p>
          <ul className="space-y-3">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-${l.to.replace("/", "")}-link`} className={linkCls}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 relative z-10">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-8">
          <p className="text-xs text-paper/50 leading-relaxed max-w-3xl">
            Les contenus de Contre-épreuve peuvent être cités sous réserve de mentionner leur auteur,
            leur titre et leur adresse d'origine. Toute reproduction intégrale nécessite une
            autorisation préalable.
          </p>
          <p className="text-xs text-paper/40 mt-4">© {new Date().getFullYear()} Contre-épreuve.</p>
        </div>
      </div>
    </footer>
  );
};
